var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.TuiSelect,{attrs:{"value":_setup.currentValue},on:{"input":function($event){_setup.currentValue = $event}}},_vm._l((_setup.yearDates),function(item){return _c(_setup.TuiOption,{key:item.value,attrs:{"value":item.value,"label":item.label}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }